/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * ally object
 * @export
 * @interface GetWarsWarIdAlly
 */
export interface GetWarsWarIdAlly {
    /**
     * Alliance ID if and only if this ally is an alliance
     * @type {number}
     * @memberof GetWarsWarIdAlly
     */
    allianceId?: number;
    /**
     * Corporation ID if and only if this ally is a corporation
     * @type {number}
     * @memberof GetWarsWarIdAlly
     */
    corporationId?: number;
}

/**
 * Check if a given object implements the GetWarsWarIdAlly interface.
 */
export function instanceOfGetWarsWarIdAlly(value: object): value is GetWarsWarIdAlly {
    return true;
}

export function GetWarsWarIdAllyFromJSON(json: any): GetWarsWarIdAlly {
    return GetWarsWarIdAllyFromJSONTyped(json, false);
}

export function GetWarsWarIdAllyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWarsWarIdAlly {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceId': json['alliance_id'] == null ? undefined : json['alliance_id'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
    };
}

export function GetWarsWarIdAllyToJSON(json: any): GetWarsWarIdAlly {
    return GetWarsWarIdAllyToJSONTyped(json, false);
}

export function GetWarsWarIdAllyToJSONTyped(value?: GetWarsWarIdAlly | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_id': value['allianceId'],
        'corporation_id': value['corporationId'],
    };
}

